import { logDOM } from "@testing-library/react";
import { MenuButtonWide } from "react-bootstrap-icons";
import { Link } from "react-router-dom";

import { useState } from 'react';
import { useSpring, animated, Spring } from 'react-spring'
import VisibilitySensor from "react-visibility-sensor";


import logo from "./../images/logo1.png";


function NavBar(props) {

	const [isInView, setIsInView] = useState(false);

	const onVisibilityChange = isInView => setIsInView(isInView);


	const fadeInButton = useSpring({
		from: { opacity: isInView ? 0 : 1 },
		to: { opacity: isInView ? 1 : 0, transform: isInView ? "translate(0, 0)" : "translate(0, -40px)" },
		delay: isInView ? 200 : 0,
		config: { duration: isInView ? 1000 : 0 }
	})


	return (
		<div className="" >
			<div
				className="row p-2 justify-content-center top-offer-bar"
			>
				<div className="col-sm-12" style={{ textAlign: "center" }}>
					<h6>
						<a href="https://app.edistillery.com.au" target="_blank" className="top-bar-visit-link">
							Register now
						</a>
						and get 95% off for the first 4 months
					</h6>
				</div>
			</div>
			<div
				className="row justify-content-center align-items-center "
			>
				<div className="col-sm-12 col-md-3 col-lg-3">
					<a href="https://www.edistillery.com.au">
						<img src={logo} alt="" className="logo img-fluid" />
					</a>
				</div>

				<div className="col-sm-12 col-md-9 col-lg-9  pl-5">

					<VisibilitySensor
						onChange={onVisibilityChange}
						partialVisibility={true}
					>
						{({ isVisible }) => (
							<animated.div style={fadeInButton}>

								<nav class="navbar navbar-expand-lg ">
									<div class="container-fluid">
										<div class="navbar-header">
											<span
												type="button"
												className="d-lg-none navbar-toggle collapsed "
												data-toggle="collapse"
												data-target=".navbar-collapse"
												aria-expanded="false"
											>
												<MenuButtonWide /> Menu
											</span>
										</div>
										<div class="collapse navbar-collapse" id="navbarNavDropdown" >
											<ul class="navbar-nav ml-auto">
												<li class="nav-item">
													<Link
														className="nav-link"
														to="/why-edistillery"
														onClick={() => {
															props.setWebPage("WhyEdistillery2");
															props.setScrollable(true);
														}}
													>
														Why eDistillery ?
													</Link>
												</li>


												<li class="nav-item">
													<Link
														className="nav-link"
														to="/dedicated-for"
														onClick={() => {
															props.setWebPage("DedicatedFor");
															props.setScrollable(true);
														}}
													>
														Dedicated For
													</Link>
												</li>


												{/* <li class="nav-item">
													<Link
														className="nav-link"
														to="/features"
														onClick={() => {
															props.setWebPage("Features");
															props.setScrollable(true);
														}}
													>
														Features
													</Link>
												</li> */}


												<li class="nav-item">
													<Link
														className="nav-link"
														to="/the-alcohol-book"
														onClick={() => {
															props.setWebPage("TheAlcoholBook");
															props.setScrollable(true);
														}}
													>
														The Alcohol Book
													</Link>
												</li>
												{/* 
									<li class="nav-item">
										<Link
											className="nav-link"
											to="watch-video"
											onClick={() => {
												props.setWebPage("WatchVideo");
												props.setScrollable(true);
											}}
										>
											Watch Video
										</Link>
									</li>
									*/}

												<li class="nav-item">
													<Link
														className="nav-link"
														to="/support"
														onClick={() => {
															props.setWebPage("SupportCare");
															props.setScrollable(true);
														}}
													>
														Support & Care
													</Link>
												</li>
												<li class="nav-item">
													<Link
														className="nav-link"
														to="/pricing"
														onClick={() => {
															props.setWebPage("Pricing");
															props.setScrollable(true);
														}}
													>
														Pricing
													</Link>
												</li>
												{/* <li class="nav-item">
													<Link
														className="nav-link"
														to="/app-guide"
														onClick={() => {
															props.setWebPage("AppGuide");
															props.setScrollable(false);
														}}
													>
														App Guide
													</Link>
												</li> */}
												<li class="nav-item">
													<Link
														className="nav-link"
														to="/contact-us"
														onClick={() => {
															props.setWebPage("ContactUs");
															props.setScrollable(true);
														}}
													>
														Contact Us
													</Link>
												</li>
											</ul>
										</div>
										{/* 
										<div className="dropdown">
											<button
												className="btn dropdown-toggle"
												data-toggle="dropdown"
												aria-haspopup="true"
												aria-expanded="false"
												style={{ color: "#092e58" }}
											>
												EN
								</button>
											<div className="dropdown-menu" style={{ minWidth: "auto" }}>
												<a className="dropdown-item w-100" href="#">
													DE
									</a>
												<a className="dropdown-item w-100" href="#">
													FR
									</a>
											</div>
										</div>
										*/}
									</div>
								</nav>

							</animated.div>
						)}
					</VisibilitySensor>


				</div>
			</div>
		</div>
	);
}

export default NavBar;
